import { ISession } from "../../../session/domain/ISession";
import { SystemType } from "../../domain/enums/SystemType";
import { OrderPadType } from "../../interface/Device";
import { IDeviceProfile } from "../../interface/DeviceProfile";
import { OperationMode } from '../../presentation/context/OperationMode';

export const IsSystemTypeAction = (deviceConfig: IDeviceProfile, _systemType: SystemType) => {
    return !!deviceConfig?.operation.methods?.find(item => item.type === _systemType && item.enabled);
}

export const GetOperationModeAction = (deviceConfig?: IDeviceProfile, session?: ISession) => {    
    if (deviceConfig) {
        if (IsSystemTypeAction(deviceConfig, SystemType.pospayOrderPad)) {
            if (session && session.orderPadType === OrderPadType.INDIVIDUAL) {
                return OperationMode.ORDER_PAD;
            }
            return OperationMode.TABLE;
        } else if (IsSystemTypeAction(deviceConfig, SystemType.prepayCashless)) {
            return OperationMode.CASHLESS;
        } else if (IsSystemTypeAction(deviceConfig, SystemType.prepayTicket)) {
            return OperationMode.TICKET;
        } else {
            return OperationMode.TICKET;
        }
    }
}